import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useController } from 'react-hook-form';
import Action from '../Action';
import { FormInputLabel, FormItemContainer } from '../StyledComponents';
import Grid from '@material-ui/core/Grid';
import { toggleObjectInArray } from "../../utils/utils";

// A props "values" recebe um array de (1 ou mais) objetos,
// com as informações do radio input: values={[{placeholder: string, value: unknown}]}

const ActionsGroup = ({
  name,
  control,
  rules,
  title,
  title2,
  onChangeDefault,
  notRequired = false,
  requiredColor = '#0061C6',
  actions = [],
  nameAction,
  descAction,
  id = 'id',
}) => {
  const {
    field: {onChange},
    fieldState: {error},
  } = useController({control, name, rules});
  
  const [filteredActions, setFilteredActions] = useState([]);
  
  actions.sort((a, b) => {
    const valorA = a['nomeAcao'];
    const valorB = b['nomeAcao'];
    const direction = 'ASC';
    if (direction === 'DESC') {
      if (valorA < valorB) return 1;
      if (valorA > valorB) return -1;
    } else {
      if (valorA < valorB) return -1;
      if (valorA > valorB) return 1;
    }
    return 0;
  });
  
  useEffect(() => {
    if (actions.length) {
      const filtered = actions.filter(i => i.id !== null);
      setFilteredActions(filtered);
    }
  }, [actions]);
  
  useEffect(() => {
    onChange(filteredActions);
  }, [filteredActions, onChange]);
  
  const renderError = () =>
      error && error.message ? (
          <p
              style={{
                color: error?.message ? '#F5365C' : '#000000',
              }}
          >
            {error?.message}
          </p>
      ) : null;
  
  
  const checkItens = async (item) => {
    setFilteredActions(prevState => toggleObjectInArray(prevState, item, 'codAcaoSeq'));
  };
  
  const handleItens = useCallback( (item, index, targetValue) => {
        const newValue = filteredActions?.map((i) => {
          if (i[id] === item) {
            i[index] = targetValue;
          }
          return i;
        });
        onChange(newValue);
  },   [onChange, filteredActions, id])
  
  
  const renderItems = useMemo(() => {
    return (
        <>
          {actions?.map((item, index) => (
              <Action
                  {...{name, control, rules, onChangeDefault}}
                  disabled={!filteredActions?.find((i) => i['codAcaoSeq'] === item['codAcaoSeq'])}
                  key={index}
                  placeholder={item.placeholder}
                  checked={filteredActions?.find((i) => i['codAcaoSeq'] === item['codAcaoSeq'])}
                  onCheck={checkItens}
                  onChange={handleItens}
                  value={item}
                  nameAction={nameAction}
                  descAction={descAction}
                  id={id}
              />
          )) || <div/>}
        </>
    );
  }, [control, name, onChangeDefault, rules, actions, filteredActions, descAction, id, nameAction, handleItens]);
  
  return (
      <FormItemContainer>
        <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="flex-start"
        >
          <Grid item md>
            <FormInputLabel>
              <label>
                {title}{' '}
                {!notRequired && (
                    <strong style={{color: requiredColor}}>*</strong>
                )}
              </label>
            </FormInputLabel>
          </Grid>
          <Grid item md>
            <FormInputLabel>
              <label>
                {title2}{' '}
                {/* {!notRequired && (
                <strong style={{ color: requiredColor }}>*</strong>
              )} */}
              </label>
            </FormInputLabel>
          </Grid>
        </Grid>
        {renderItems}
        {renderError()}
      </FormItemContainer>
  );
};

export default ActionsGroup;
